<template>
    <div style="" class="pics3-box">
        <div class="image-box" v-for="(item,i) in content" style="">
            
            <img v-if="item.pic.length==0" style="width:100%;" src="https://api-xiangyou.dierqudao.com/public/images/no-pic.png" alt="" srcset="">
            <img v-else style="width:100%;" :src="item.pic[0].url" alt="" srcset="">
        </div>
    </div>
</template>

<script> 
    export default {
        name: "Pics2",
        components: {
        },
        props: {
            content: {
                type: Array,
                default: [],
            },

        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>
.pics3-box{
    display:flex;
    justify-content: space-around;
}
    .image-box{
        
    } 
</style>